import React from 'react';
import { uploadFiles } from '../../hooks/useOrderUpload';
import { UploadAsset } from '../ui/UploadAsset';
import UploadBox from './UploadBox';

type NormalizedPurpose = {
	name: string;
	resultTypes: Array<{ name: string; id?: number }>;
};

type OrderUpload = {
	purpose: string;
	resultType: string;
	fileName?: unknown;
	name?: unknown;
	size?: unknown;
	[key: string]: unknown;
};

interface OrderUploadSectionProps {
	orderId: string;
	orderUploads?: OrderUpload[] | null;
	normalizedPurposes: NormalizedPurpose[];
}

export default function OrderUploadSection({
	orderId,
	orderUploads = [],
	normalizedPurposes,
}: OrderUploadSectionProps) {
	const uploadsList = orderUploads ?? [];

	return (
		<>
			<div className="upload-container">
				{normalizedPurposes.map((purpose, i) =>
					purpose.resultTypes?.map((resultType, j) => {
						const uploads = uploadsList.filter(
							(upload) =>
								upload.purpose === purpose.name &&
								upload.resultType === resultType.name
						);

						return (
							<div key={i + '.' + j} className="mb-5">
								<h4 className="font-bold text-base mb-3">
									{purpose.name + ':'}
									<span className="font-bold text-base text-[#333333]">
										{resultType.name}
									</span>
								</h4>

								<UploadBox
									maxSize={50}
									files={uploads.map((upload) => ({
										name: String(upload.fileName ?? upload.name ?? ''),
										size: typeof upload.size === 'number' ? upload.size : undefined,
									}))}
									onSelect={(files) =>
										uploadFiles({
											files,
											orderId,
											purpose: purpose.name,
											resultType: resultType.name,
											normalizedPurposes,
										})
									}
								/>

								{uploads.map((upload, k) => (
									<UploadAsset
										key={k}
										orderId={orderId}
										upload={upload as unknown as React.ComponentProps<typeof UploadAsset>['upload']}
									/>
								))}
							</div>
						);
					})
				)}
			</div>
		
		</>
	);
}
